export default "__VITE_ASSET__DdEOcP2X__"